import {initI18next} from '@treatwell/tolgee/client';
import translationEn from '../../locales/en.json';

export const handleLocaleError = (error: Error) => {
  initI18next('en', translationEn);
  console.error(
    `recover from static locales failure - using en\n\n${error.message}`
  );
};
